export default __webpack_public_path__ + "static/media/ec8cc854-604b-4499-810f-43668c3caa06_IMG_20211007_120344.9cf5a6e5.jpeg";